import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const state = {
  athleteList: [],
  athleteResults: [],
  athleteOfficialResults: [],
  resultsList: [],
  allClubFormData: [],
  allPersonCommunications: [],
  clubPersonRel: []
};

export default {
  state,
  getters,
  mutations,
  actions
};
